// extracted by mini-css-extract-plugin
export default {"panelContainer":"panel-content_panelContainer__TZixT","closeSection":"panel-content_closeSection__Mtrye","firstIcon":"panel-content_firstIcon__j92Wx"};